/**
 * @deprecated
 */
export type DropDownFilter = {
  options: [number, string][];
  selectedKey: number;
  isReadOnly: boolean;
};

/**
 * @deprecated
 */
export type CheckboxFilter = {
  selectedKey: boolean;
};

/**
 * Creates a DropDownFilter given a subset of keys and a dictionary with values
 *
 *
 * @param keys - valid keys for whatever filter we are initializing
 * @param values - corresponding values for those keys we are using to build filters
 * @deprecated
 */
export const createFilterWithChoices = (keys: number[], values: { [key: number]: string }): DropDownFilter => {
  const options = keys.reduce<[number, string][]>((acc, key) => {
    const val = values[key];
    if (val !== undefined) acc.push([key, val]);
    return acc;
  }, []);

  const createdFilter: DropDownFilter = {
    options,
    selectedKey: 0,
    isReadOnly: false
  };

  if (options.length === 1 || options.length === 0) createdFilter.isReadOnly = true;
  if (options.length === 1) createdFilter.selectedKey = options[0]?.[0] as number;

  return createdFilter;
};
